import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { AppsColumnConfigDto, AppsColumnSelectionRequestDto } from "../../types/dto";

const buildColumnConfigUrl = (appOs: AppOperatingSystem) => `/sales-api/search-apps/${appOs}/columns`;

export const createAppsColumnConfigApiService = (fetchService: IFetchService) => {
    return {
        fetchColumnConfig(
            appOs: AppOperatingSystem,
            options?: Readonly<GetRequestOptions>,
        ): Promise<AppsColumnConfigDto> {
            return fetchService.get(buildColumnConfigUrl(appOs), undefined, options);
        },

        saveColumnSelection(appOs: AppOperatingSystem, dto: Readonly<AppsColumnSelectionRequestDto>): Promise<void> {
            return fetchService.put(buildColumnConfigUrl(appOs), dto);
        },
    };
};
